import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.TrancheBooking';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class TrancheBooking extends RpcClass{

    /**
     *  @class TrancheBooking
     *  @alias module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking
     *  
     * */
    constructor(){
        super();

        /** @type {LocalDate}  */
        this.ATA = null;
        /** @type {LocalDate}  */
        this.ATD = null;
        /** @type {string}  */
        this.BLNumber = null;
        /** @type {BigDecimal}  */
        this.CBM = null;
        /** @type {string}  */
        this.EID = null;
        /** @type {LocalDate}  */
        this.ETA = null;
        /** @type {LocalDate}  */
        this.ETD = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.allInCost = null;
        /** @type {boolean}  */
        this.allInCostAccept = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {number}  */
        this.cartons = null;
        /** @type {LocalDate}  */
        this.confirmationSADDraft = null;
        /** @type {string}  */
        this.containerNumber = null;
        /** @type {string}  */
        this.containerType = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.dateDPP = null;
        /** @type {LocalDate}  */
        this.deliveryDate = null;
        /** @type {string}  */
        this.deliveryPort = null;
        /** @type {boolean}  */
        this.descriptionDPPAccept = null;
        /** @type {string}  */
        this.forwarding = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.freightCost = null;
        /** @type {BigDecimal}  */
        this.grossWeightField = null;
        /** @type {string}  */
        this.id = null;
        /** @type {boolean}  */
        this.isIntegrationFrozen = null;
        /** @type {BigDecimal}  */
        this.netWeight = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {string}  */
        this.numberInvoice = null;
        /** @type {string}  */
        this.placeOfDelivery = null;
        /** @type {string}  */
        this.port = null;
        /** @type {number}  */
        this.quantity = null;
        /** @type {boolean}  */
        this.readyToIntegrationWithShipsGo = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.released = null;
        /** @type {string}  */
        this.shipowner = null;
        /** @type {LocalDate}  */
        this.shippingOrderDate = null;
        /** @type {LocalDate}  */
        this.shippingToForwarding = null;
        /** @type {string}  */
        this.status = null;
        /** @type {number}  */
        this.storage = null;
        /** @type {LocalDateTime}  */
        this.timestampRegistrationContainer = null;
        /** @type {LocalDateTime}  */
        this.timestampUpdate = null;
        /** @type {string}  */
        this.trancheId = null;
        /** @type {LocalDate}  */
        this.transmissionOriginals = null;
        /** @type {string}  */
        this.transportType = null;
        /** @type {*}  */
        this.uuid = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }



    /**
     * Get extension tab: Tranche Booking Additional Costs
     * @returns {Promise<TrancheBookingAdditionalCosts>}
     */

    async getTrancheBookingAdditionalCosts(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "trancheBookingId",
            "com.silkplm.model.plm.TrancheBookingAdditionalCosts");
   }


    /** @type {LocalDate}  */
    get trancheIdOrderIdEXWPI(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdEXWPI'] : null, this.__metadata__['trancheIdOrderIdEXWPI']?.remoteType);
    }
    set trancheIdOrderIdEXWPI(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdOrderIdPM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdPM'] : null, this.__metadata__['trancheIdOrderIdPM']?.remoteType);
    }
    set trancheIdOrderIdPM(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdOrderIdPMLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'trancheIdOrderIdPM',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdOrderIdPMStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'trancheIdOrderIdPM'); //  false 
    }

    /** @returns {Promise<ApplicationUser>} */
    getTrancheIdOrderIdPMEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'trancheIdOrderIdPM',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdOrderIdSupplierIdAddressLine1(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdSupplierIdAddressLine1'] : null, this.__metadata__['trancheIdOrderIdSupplierIdAddressLine1']?.remoteType);
    }
    set trancheIdOrderIdSupplierIdAddressLine1(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdCountry(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdCountry'] : null, this.__metadata__['trancheIdCountry']?.remoteType);
    }
    set trancheIdCountry(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'trancheIdCountry',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'trancheIdCountry'); //  false 
    }

    /** @returns {Promise<Country>} */
    getTrancheIdCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'trancheIdCountry',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdDeliveryType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdDeliveryType'] : null, this.__metadata__['trancheIdDeliveryType']?.remoteType);
    }
    set trancheIdDeliveryType(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdDeliveryTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryType', 'trancheIdDeliveryType',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdDeliveryTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryType', 'trancheIdDeliveryType'); //  false 
    }

    /** @returns {Promise<DeliveryType>} */
    getTrancheIdDeliveryTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryType', 'trancheIdDeliveryType',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdDescriptionDPP(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdDescriptionDPP'] : null, this.__metadata__['trancheIdDescriptionDPP']?.remoteType);
    }
    set trancheIdDescriptionDPP(val){
    }
    // fk: false

    /** @type {boolean}  */
    get trancheIdDocuments(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdDocuments'] : null, this.__metadata__['trancheIdDocuments']?.remoteType);
    }
    set trancheIdDocuments(val){
    }
    // fk: false

    /** @type {BigDecimal}  */
    get trancheIdGrossWeight(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdGrossWeight'] : null, this.__metadata__['trancheIdGrossWeight']?.remoteType);
    }
    set trancheIdGrossWeight(val){
    }
    // fk: false

    /** @type {boolean}  */
    get trancheIdInspection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdInspection'] : null, this.__metadata__['trancheIdInspection']?.remoteType);
    }
    set trancheIdInspection(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdOrderIdMerchant(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdMerchant'] : null, this.__metadata__['trancheIdOrderIdMerchant']?.remoteType);
    }
    set trancheIdOrderIdMerchant(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdOrderIdMerchantLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'trancheIdOrderIdMerchant',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdOrderIdMerchantStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'trancheIdOrderIdMerchant'); //  false 
    }

    /** @returns {Promise<ApplicationUser>} */
    getTrancheIdOrderIdMerchantEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'trancheIdOrderIdMerchant',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdOrderIdNumberOfProforma(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdNumberOfProforma'] : null, this.__metadata__['trancheIdOrderIdNumberOfProforma']?.remoteType);
    }
    set trancheIdOrderIdNumberOfProforma(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdNumberOfTranche(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdNumberOfTranche'] : null, this.__metadata__['trancheIdNumberOfTranche']?.remoteType);
    }
    set trancheIdNumberOfTranche(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdPort(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdPort'] : null, this.__metadata__['trancheIdPort']?.remoteType);
    }
    set trancheIdPort(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'trancheIdPort',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'trancheIdPort'); //  false 
    }

    /** @returns {Promise<Port>} */
    getTrancheIdPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'trancheIdPort',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdOrderIdSupplierIdPrimaryEmail(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdSupplierIdPrimaryEmail'] : null, this.__metadata__['trancheIdOrderIdSupplierIdPrimaryEmail']?.remoteType);
    }
    set trancheIdOrderIdSupplierIdPrimaryEmail(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdOrderIdSupplierIdPrimaryPhone(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdSupplierIdPrimaryPhone'] : null, this.__metadata__['trancheIdOrderIdSupplierIdPrimaryPhone']?.remoteType);
    }
    set trancheIdOrderIdSupplierIdPrimaryPhone(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get trancheIdRealEXW(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdRealEXW'] : null, this.__metadata__['trancheIdRealEXW']?.remoteType);
    }
    set trancheIdRealEXW(val){
    }
    // fk: false

    /** @type {string}  */
    get trancheIdOrderIdSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdSeasonId'] : null, this.__metadata__['trancheIdOrderIdSeasonId']?.remoteType);
    }
    set trancheIdOrderIdSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdOrderIdSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'trancheIdOrderIdSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdOrderIdSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'trancheIdOrderIdSeasonId'); //  false 
    }

    /** @returns {Promise<Season>} */
    getTrancheIdOrderIdSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'trancheIdOrderIdSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdOrderIdSupplierId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdOrderIdSupplierId'] : null, this.__metadata__['trancheIdOrderIdSupplierId']?.remoteType);
    }
    set trancheIdOrderIdSupplierId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdOrderIdSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'trancheIdOrderIdSupplierId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdOrderIdSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'trancheIdOrderIdSupplierId'); //  false 
    }

    /** @returns {Promise<Suppliers>} */
    getTrancheIdOrderIdSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'trancheIdOrderIdSupplierId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdTransportType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdTransportType'] : null, this.__metadata__['trancheIdTransportType']?.remoteType);
    }
    set trancheIdTransportType(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdTransportTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'trancheIdTransportType',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdTransportTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'trancheIdTransportType'); //  false 
    }

    /** @returns {Promise<TransportType>} */
    getTrancheIdTransportTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'trancheIdTransportType',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdTypeOfDocument(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdTypeOfDocument'] : null, this.__metadata__['trancheIdTypeOfDocument']?.remoteType);
    }
    set trancheIdTypeOfDocument(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdTypeOfDocumentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'trancheIdTypeOfDocument',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdTypeOfDocumentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'trancheIdTypeOfDocument'); //  false 
    }

    /** @returns {Promise<TypeOfDocument>} */
    getTrancheIdTypeOfDocumentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfDocument', 'trancheIdTypeOfDocument',  allowRemote); //  false 
    }

    /** @type {string}  */
    get trancheIdWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['trancheIdWarehouse'] : null, this.__metadata__['trancheIdWarehouse']?.remoteType);
    }
    set trancheIdWarehouse(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getTrancheIdWarehouseLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Warehouse', 'trancheIdWarehouse',  allowRemote); //  false 
    }

    /** @returns {String} */
    getTrancheIdWarehouseStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Warehouse', 'trancheIdWarehouse'); //  false 
    }

    /** @returns {Promise<Warehouse>} */
    getTrancheIdWarehouseEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Warehouse', 'trancheIdWarehouse',  allowRemote); //  false 
    }

    /** @type {boolean}  */
    get bookingPMApproval(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['bookingPMApproval'] : null, this.__metadata__['bookingPMApproval']?.remoteType);
    }
    set bookingPMApproval(val){
    }


    /** @type {BigDecimal}  */
    get cBMPlan(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['cBMPlan'] : null, this.__metadata__['cBMPlan']?.remoteType);
    }
    set cBMPlan(val){
    }


    /** @type {BigDecimal}  */
    get cartonsPlan(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['cartonsPlan'] : null, this.__metadata__['cartonsPlan']?.remoteType);
    }
    set cartonsPlan(val){
    }


    /** @type {number}  */
    get deliveryWeek(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['deliveryWeek'] : null, this.__metadata__['deliveryWeek']?.remoteType);
    }
    set deliveryWeek(val){
    }


    /** @type {boolean}  */
    get integration(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['integration'] : null, this.__metadata__['integration']?.remoteType);
    }
    set integration(val){
    }


    /** @type {string}  */
    get integrationStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['integrationStatus'] : null, this.__metadata__['integrationStatus']?.remoteType);
    }
    set integrationStatus(val){
    }


    /** @type {LocalDate}  */
    get plannedDateOfInspection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['plannedDateOfInspection'] : null, this.__metadata__['plannedDateOfInspection']?.remoteType);
    }
    set plannedDateOfInspection(val){
    }


    /** @type {string}  */
    get productCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productCategory'] : null, this.__metadata__['productCategory']?.remoteType);
    }
    set productCategory(val){
    }


    /** @type {boolean}  */
    get qCPMApproval(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['qCPMApproval'] : null, this.__metadata__['qCPMApproval']?.remoteType);
    }
    set qCPMApproval(val){
    }


    /** @type {number}  */
    get quantityPlan(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['quantityPlan'] : null, this.__metadata__['quantityPlan']?.remoteType);
    }
    set quantityPlan(val){
    }


    /** @type {number}  */
    get quantitySKU(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['quantitySKU'] : null, this.__metadata__['quantitySKU']?.remoteType);
    }
    set quantitySKU(val){
    }


    /** @type {string}  */
    get relatedOrderNumber(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['relatedOrderNumber'] : null, this.__metadata__['relatedOrderNumber']?.remoteType);
    }
    set relatedOrderNumber(val){
    }


    /** @type {boolean}  */
    get sanepid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sanepid'] : null, this.__metadata__['sanepid']?.remoteType);
    }
    set sanepid(val){
    }


    /** @type {number}  */
    get stockForDelivery(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['stockForDelivery'] : null, this.__metadata__['stockForDelivery']?.remoteType);
    }
    set stockForDelivery(val){
    }


    /** @type {LocalDate}  */
    get takeTo(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['takeTo'] : null, this.__metadata__['takeTo']?.remoteType);
    }
    set takeTo(val){
    }


    /** @type {number}  */
    get wMS(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMS'] : null, this.__metadata__['wMS']?.remoteType);
    }
    set wMS(val){
    }


    /** @type {LocalDate}  */
    get wMSEstimation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMSEstimation'] : null, this.__metadata__['wMSEstimation']?.remoteType);
    }
    set wMSEstimation(val){
    }


    /** @type {number}  */
    get weekReadyToExecute(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['weekReadyToExecute'] : null, this.__metadata__['weekReadyToExecute']?.remoteType);
    }
    set weekReadyToExecute(val){
    }


    /** @type {number}  */
    get weekRelativeToStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['weekRelativeToStatus'] : null, this.__metadata__['weekRelativeToStatus']?.remoteType);
    }
    set weekRelativeToStatus(val){
    }


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withATA(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ATA = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withATD(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ATD = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withBLNumber(val){
        this.BLNumber = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withCBM(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.CBM = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withETA(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ETA = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withETD(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ETD = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withAllInCost(val){
        this.allInCost = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withAllInCostAccept(val){
        this.allInCostAccept = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withCartons(val){
        this.cartons = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withConfirmationSADDraft(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.confirmationSADDraft = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withContainerNumber(val){
        this.containerNumber = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withContainerType(val){
        this.containerType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getContainerTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ContainerType', 'containerType', allowRemote); //  true 
    }

    /** @returns {String} */
        getContainerTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ContainerType', 'containerType'); //  true 
    }

        /** @returns {Promise<ContainerType>} */
    getContainerTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ContainerType', 'containerType', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withDateDPP(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateDPP = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withDeliveryDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.deliveryDate = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withDeliveryPort(val){
        this.deliveryPort = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDeliveryPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /** @returns {String} */
        getDeliveryPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort'); //  true 
    }

        /** @returns {Promise<DeliveryPort>} */
    getDeliveryPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withDescriptionDPPAccept(val){
        this.descriptionDPPAccept = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withForwarding(val){
        this.forwarding = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getForwardingLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Forwarding', 'forwarding', allowRemote); //  true 
    }

    /** @returns {String} */
        getForwardingStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Forwarding', 'forwarding'); //  true 
    }

        /** @returns {Promise<Forwarding>} */
    getForwardingEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Forwarding', 'forwarding', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withFreightCost(val){
        this.freightCost = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withGrossWeightField(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.grossWeightField = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withIsIntegrationFrozen(val){
        this.isIntegrationFrozen = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withNetWeight(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.netWeight = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withNumberInvoice(val){
        this.numberInvoice = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withPlaceOfDelivery(val){
        this.placeOfDelivery = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPlaceOfDeliveryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.PlaceOfDelivery', 'placeOfDelivery', allowRemote); //  true 
    }

    /** @returns {String} */
        getPlaceOfDeliveryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.PlaceOfDelivery', 'placeOfDelivery'); //  true 
    }

        /** @returns {Promise<PlaceOfDelivery>} */
    getPlaceOfDeliveryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.PlaceOfDelivery', 'placeOfDelivery', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withPort(val){
        this.port = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /** @returns {String} */
        getPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'port'); //  true 
    }

        /** @returns {Promise<Port>} */
    getPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withQuantity(val){
        this.quantity = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withReadyToIntegrationWithShipsGo(val){
        this.readyToIntegrationWithShipsGo = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withReleased(val){
        this.released = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getReleasedLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Released', 'released', allowRemote); //  true 
    }

    /** @returns {String} */
        getReleasedStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Released', 'released'); //  true 
    }

        /** @returns {Promise<Released>} */
    getReleasedEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Released', 'released', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withShipowner(val){
        this.shipowner = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getShipownerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Shipowner', 'shipowner', allowRemote); //  true 
    }

    /** @returns {String} */
        getShipownerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Shipowner', 'shipowner'); //  true 
    }

        /** @returns {Promise<Shipowner>} */
    getShipownerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Shipowner', 'shipowner', allowRemote); //  true 
    }

    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withShippingOrderDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.shippingOrderDate = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withShippingToForwarding(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.shippingToForwarding = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withStatus(val){
        this.status = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.LogisticStatus', 'status', allowRemote); //  true 
    }

    /** @returns {String} */
        getStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.LogisticStatus', 'status'); //  true 
    }

        /** @returns {Promise<LogisticStatus>} */
    getStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.LogisticStatus', 'status', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withStorage(val){
        this.storage = val;
        return this;
    };


    /**
     * @param val {LocalDateTime}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withTimestampRegistrationContainer(val){
        let rawValue = val;
        let v = val;
        v = new LocalDateTime(); v.value = rawValue;
        this.timestampRegistrationContainer = v;
        return this;
    };


    /**
     * @param val {LocalDateTime}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withTimestampUpdate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDateTime(); v.value = rawValue;
        this.timestampUpdate = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withTrancheId(val){
        this.trancheId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTrancheIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Tranche', 'trancheId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTrancheIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Tranche', 'trancheId'); //  true 
    }

        /** @returns {Promise<Tranche>} */
    getTrancheIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Tranche', 'trancheId', allowRemote); //  true 
    }

    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withTransmissionOriginals(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.transmissionOriginals = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withTransportType(val){
        this.transportType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTransportTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'transportType', allowRemote); //  true 
    }

    /** @returns {String} */
        getTransportTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'transportType'); //  true 
    }

        /** @returns {Promise<TransportType>} */
    getTransportTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'transportType', allowRemote); //  true 
    }

    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withUuid(val){
        this.uuid = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/TrancheBooking.TrancheBooking}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<TrancheBooking>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadTrancheBooking(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'trancheIdOrderIdPM'){
            return this.getTrancheIdOrderIdPMLabel(allowRemote);
        }
        if(fiendName === 'trancheIdCountry'){
            return this.getTrancheIdCountryLabel(allowRemote);
        }
        if(fiendName === 'trancheIdDeliveryType'){
            return this.getTrancheIdDeliveryTypeLabel(allowRemote);
        }
        if(fiendName === 'trancheIdOrderIdMerchant'){
            return this.getTrancheIdOrderIdMerchantLabel(allowRemote);
        }
        if(fiendName === 'trancheIdPort'){
            return this.getTrancheIdPortLabel(allowRemote);
        }
        if(fiendName === 'trancheIdOrderIdSeasonId'){
            return this.getTrancheIdOrderIdSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'trancheIdOrderIdSupplierId'){
            return this.getTrancheIdOrderIdSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'trancheIdTransportType'){
            return this.getTrancheIdTransportTypeLabel(allowRemote);
        }
        if(fiendName === 'trancheIdTypeOfDocument'){
            return this.getTrancheIdTypeOfDocumentLabel(allowRemote);
        }
        if(fiendName === 'trancheIdWarehouse'){
            return this.getTrancheIdWarehouseLabel(allowRemote);
        }
        if(fiendName === 'containerType'){
            return this.getContainerTypeLabel(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortLabel(allowRemote);
        }
        if(fiendName === 'forwarding'){
            return this.getForwardingLabel(allowRemote);
        }
        if(fiendName === 'placeOfDelivery'){
            return this.getPlaceOfDeliveryLabel(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortLabel(allowRemote);
        }
        if(fiendName === 'released'){
            return this.getReleasedLabel(allowRemote);
        }
        if(fiendName === 'shipowner'){
            return this.getShipownerLabel(allowRemote);
        }
        if(fiendName === 'status'){
            return this.getStatusLabel(allowRemote);
        }
        if(fiendName === 'trancheId'){
            return this.getTrancheIdLabel(allowRemote);
        }
        if(fiendName === 'transportType'){
            return this.getTransportTypeLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'containerType'){
            return this.getContainerTypeEntity(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortEntity(allowRemote);
        }
        if(fiendName === 'forwarding'){
            return this.getForwardingEntity(allowRemote);
        }
        if(fiendName === 'placeOfDelivery'){
            return this.getPlaceOfDeliveryEntity(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortEntity(allowRemote);
        }
        if(fiendName === 'released'){
            return this.getReleasedEntity(allowRemote);
        }
        if(fiendName === 'shipowner'){
            return this.getShipownerEntity(allowRemote);
        }
        if(fiendName === 'status'){
            return this.getStatusEntity(allowRemote);
        }
        if(fiendName === 'trancheId'){
            return this.getTrancheIdEntity(allowRemote);
        }
        if(fiendName === 'transportType'){
            return this.getTransportTypeEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<TrancheBooking>}
 */
async function loadTrancheBooking(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<TrancheBooking[]>}
 */
async function listTrancheBooking(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelTrancheBooking(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<TrancheBooking>}
 */
TrancheBooking.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<TrancheBooking[]>}
 */
TrancheBooking.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<TrancheBooking[]>}
 */
TrancheBooking.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<TrancheBooking[]>}
 */
TrancheBooking.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<TrancheBooking>}
 */
TrancheBooking.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return TrancheBooking.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
TrancheBooking.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
TrancheBooking.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
TrancheBooking.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
TrancheBooking.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
TrancheBooking.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['ATA'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['ATD'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['BLNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['CBM'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['ETA'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['ETD'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['allInCost'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['allInCostAccept'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['cartons'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['confirmationSADDraft'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['containerNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['containerType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dateDPP'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['deliveryDate'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['deliveryPort'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['descriptionDPPAccept'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['forwarding'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['freightCost'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['grossWeightField'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['isIntegrationFrozen'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['netWeight'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['numberInvoice'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['placeOfDelivery'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['port'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['quantity'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['readyToIntegrationWithShipsGo'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['released'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shipowner'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shippingOrderDate'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['shippingToForwarding'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['status'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['storage'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['timestampRegistrationContainer'] = {'remoteType' : 'java.time.LocalDateTime', 'jsType' : 'LocalDateTime', 'mapped' : 'true'};
metadata['timestampUpdate'] = {'remoteType' : 'java.time.LocalDateTime', 'jsType' : 'LocalDateTime', 'mapped' : 'true'};
metadata['trancheId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['transmissionOriginals'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['transportType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['uuid'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['bookingPMApproval'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cBMPlan'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['cartonsPlan'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['deliveryWeek'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['integration'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['integrationStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['plannedDateOfInspection'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['productCategory'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['qCPMApproval'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['quantityPlan'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['quantitySKU'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['relatedOrderNumber'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sanepid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['stockForDelivery'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['takeTo'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['wMS'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['wMSEstimation'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['weekReadyToExecute'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['weekRelativeToStatus'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['trancheIdOrderIdEXWPI'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheIdOrderIdPM'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdOrderIdSupplierIdAddressLine1'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdCountry'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdDeliveryType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdDescriptionDPP'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdDocuments'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheIdGrossWeight'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['trancheIdInspection'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['trancheIdOrderIdMerchant'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdOrderIdNumberOfProforma'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdNumberOfTranche'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdPort'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdOrderIdSupplierIdPrimaryEmail'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdOrderIdSupplierIdPrimaryPhone'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdRealEXW'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['trancheIdOrderIdSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdOrderIdSupplierId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdTransportType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdTypeOfDocument'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['trancheIdWarehouse'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.TrancheBooking';
metadata.__type_short__ = 'TrancheBooking';
TrancheBooking.prototype.__metadata__ = metadata;

TrancheBooking.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/TrancheBooking */
export default TrancheBooking

export { TrancheBooking , loadTrancheBooking, listTrancheBooking, labelTrancheBooking }
